import {MessageModel} from '../services/message.service';

export class FormParams {
  type?: string;
  process?: string;
  message?: MessageModel;
}
